import { render } from "./recover-password.html?vue&type=template&id=62f99276&ts=true"
import script from "./recover-password.ts?vue&type=script&lang=ts"
export * from "./recover-password.ts?vue&type=script&lang=ts"

import "./recover-password.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__